import { inject, Injectable } from '@angular/core';
import { RrcLimitsCopyApiService } from "./rrc-limits-copy-api.service";
import { CopyRrcLimitParams } from "../types/rrc-limits-copy-config.types";

@Injectable({
  providedIn: 'root'
})
export class RrcLimitsCopyService {
  private rrcLimitsCopyApiService: RrcLimitsCopyApiService = inject(RrcLimitsCopyApiService);

  public copyRrcLimit(params: CopyRrcLimitParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.rrcLimitsCopyApiService.copyRrcLimit(params).subscribe({
        next: () => resolve(),
        error: () => reject()
      });
    });
  }
}
